import { render, staticRenderFns } from "./StackedMomentsModal.vue?vue&type=template&id=5bcd8b4d"
import script from "./StackedMomentsModal.vue?vue&type=script&lang=js"
export * from "./StackedMomentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports